export enum DocStatusEnum {
  Checked = 'checked',
  Unchecked = 'unchecked',
  Rejected = 'rejected',
}

export enum DocumentStatusType {
  Open = 'open',
  Closed = 'closed',
}
